import classNames from 'classnames'
import {SvgIcon} from './SvgIcon'

export const LawScaleIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = '',
  ariaLabel,
  datacy,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-label={ariaLabel}
    data-cy={datacy}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(classes, {
      'text-gray-1000 fill-dope-black': !classes,
    })}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 21h13M12 21V7m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2-1.8c3.073.661 2.467 2.8 5 2.8M5 8c3.359 0 2.192-2.115 5.012-2.793M7 9.556V7.75m0 1.806-1.95 4.393a.773.773 0 0 0 .37.962.785.785 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.776.776 0 0 0 .09-.716L7 9.556Zm10 0V7.313m0 2.243-1.95 4.393a.773.773 0 0 0 .37.962.786.786 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.775.775 0 0 0 .09-.716L17 9.556Z"
    />
  </svg>
)

export const FileIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = 'text-gray-1000',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    aria-label={ariaLabel}
    data-cy={datacy}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M5.16634 12.8334H10.833C11.5694 12.8334 12.1663 12.2365 12.1663 11.5001V6.00008L9.33301 3.16675H5.16634C4.42996 3.16675 3.83301 3.7637 3.83301 4.50008V11.5001C3.83301 12.2365 4.42996 12.8334 5.16634 12.8334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0003 6.16659H9.16699V3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
